import { DrawerPortals } from './DrawerPortals';
import { useDrawerStore } from '../useDrawerStore';

export const MainDrawerPortals = () => {
  const isChildrenProviderMounted = useDrawerStore((state) => state.isChildrenProviderMounted);

  if (isChildrenProviderMounted) {
    return null;
  }

  return <DrawerPortals />;
};
